<ng-container *transloco="let t">
  <h2 mat-dialog-title>
    {{
      (notificationRepo.mode$ | async) === 'unread'
        ? t('NOTIFICATIONS.UNREAD_NOTIFICATIONS')
        : t('NOTIFICATIONS.ALL_NOTIFICATIONS')
    }}
  </h2>

  <button mat-icon-button class="close-button" mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>

  <mat-dialog-content #ScrollContainer>
    @if (notificationRepo.notifications$ | async; as notifications) {
      @if (notifications.length) {
        <div
          class="notifications-list"
          infiniteScroll
          [infiniteScrollContainer]="ScrollContainer"
          [infiniteScrollDisabled]="!!(notificationRepo.error$ | async)"
          [infiniteScrollThrottle]="250"
          [scrollWindow]="false"
          (scrolled)="fetchNextPage()"
        >
          @for (notification of notifications; track notification.id) {
            <sandoz-notification-item
              [notification]="notification"
              [class.unread]="!notification.read"
            ></sandoz-notification-item>
          }
        </div>
      }

      @if (notificationRepo.loading$ | async) {
        <div class="loading-container">
          <mat-spinner></mat-spinner>
        </div>
      }

      @if (
        (notificationRepo.nextPage$ | async) &&
        !(notificationRepo.loading$ | async) &&
        !(notificationRepo.error$ | async)
      ) {
        <div class="results-bottom-container">
          <button mat-flat-button color="primary" (click)="fetchNextPage()">
            {{ t('GENERAL.LOAD_MORE') }}
          </button>
        </div>
      }

      @if (
        !(notificationRepo.loading$ | async) &&
        !(notificationRepo.notifications$ | async)?.length
      ) {
        <h3 class="secondary-heading">
          {{ t('NOTIFICATIONS.NO_NEW_NOTIFICATIONS') }}
        </h3>
      }
    }
  </mat-dialog-content>

  <mat-dialog-actions>
    <span class="spacer"></span>

    @if ((notificationRepo.mode$ | async) === 'unread') {
      <button
        mat-flat-button
        color="primary"
        [disabled]="notificationRepo.loading$ | async"
        (click)="notificationRepo.setMode('all')"
      >
        {{ t('GENERAL.SEE_ALL') }}
      </button>
    }

    @if ((notificationRepo.mode$ | async) === 'all') {
      <button
        mat-flat-button
        color="primary"
        [disabled]="notificationRepo.loading$ | async"
        (click)="notificationRepo.setMode('unread')"
      >
        {{ t('NOTIFICATIONS.SEE_UNREAD_NOTIFICATIONS') }}
      </button>
    }

    <span class="spacer"></span>
  </mat-dialog-actions>
</ng-container>
